import React from 'react';
import { Navigate } from 'react-router-dom';
import ServiceLocator from './ServiceLocator';

const PrivateRoute: React.FC<{ element: JSX.Element }> = ({ element }) => {
    const authenticator = ServiceLocator.Authenticator;
    const isAuthenticated = authenticator.IsAuthenticated();
    return isAuthenticated ? element : <Navigate to='/login' />;
};

export default PrivateRoute;
